import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    annexedContractsDataTable: {
      margin: '0 auto',
      width: '100%'
    },
    form: {}
  })
